
import superagent from 'superagent'
export const fetchPrivateAddMarkersAction = payload => ({
    type: 'PRIVATE_LAND_ADD_MARKERS',
    payload: payload
})

export const fetchPrivateRemoveMarkersAction = payload => ({
    type: 'PRIVATE_LAND_REMOVE_MARKERS',
    payload: payload
})